import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import ToolbarMui from "@mui/material/Toolbar";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import Grid from "@mui/material/Grid";
import {TimeUtil} from "../utils/TimeUtil";
import {Snackbar} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import {BASE_URL_API} from "../Const";
import {BackButton,BottomMenu} from './HookUtils'


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class OrderComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            orderList: [],
            openSnackbar: false,
            message: "",
            snackbarType: "success",
        }
    }

    componentDidMount() {
        this.fetchOrderList()
    }

    fetchOrderList = () => {
        fetch(BASE_URL_API + 'order', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code === 200) {
                        this.setState({orderList: results.data})
                    }

                },
                (error) => {
                    console.log("error")
                }
            );
    }


    render() {

        const onConfirmOrder = (orderId) => {
            console.log(orderId)
            fetch(BASE_URL_API + 'order/confirm', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    order_id: orderId
                })
            })
                .then(response => response.json())
                .then(result => {
                    if (result.code === 200) {
                        this.setState({openSnackbar: true, message: result.message, snackbarType: "success"})

                        this.fetchOrderList()
                    } else {
                        this.setState({openSnackbar: true, message: result.message, snackbarType: "error"})
                    }


                })
        };
        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }

        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ShoppingBasketOutlinedIcon style={{color: 'black'}}/>

                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }} >{"سفارشات"}</strong></ListItemText>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>
                <List style={{marginTop: 70}}> {this.state.orderList.map((item) => (

                    <ListItem key={item.id} style={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{maxWidth: 700}}>
                            <Paper>
                                <ListItemText style={{align: 'right'}}>
                                    <Grid container>
                                        <Grid item xs={3} style={{background: "#fafafa"}}>
                                            <p style={{
                                                marginRight: 12,
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: '#313131',
                                                fontWeight: 'bold',
                                                fontSize: 14
                                            }}
                                               align='right'>
                                                {item.market == null ? ("نامشخص") :
                                                    item.market.name
                                                }

                                            </p>
                                        </Grid>
                                        <Grid item xs={6} style={{background: "#fafafa"}}>
                                            <p style={{
                                                marginRight: 12,
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'green',
                                                fontSize: 14
                                            }}
                                               align='right'>{"وضعیت: "}
                                                {item.status === "failed" ? "ناموفق" : ""}
                                                {item.status === "completed" ? "تکمیل سفارش" : ""}
                                                {item.status === "ready_for_send" ? "در انتظار تایید پذیرنده" : ""}
                                                {item.status === "payment" ? "در انتظار پرداخت" : ""}
                                                {item.status === "delivery" ? "در حال ارسال محصول" : ""}
                                            </p>
                                        </Grid>

                                        <Grid item xs={3} style={{background: "#fafafa"}}>
                                            <p style={{
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'gray',
                                                fontSize: 14
                                            }}
                                               align='center'>{TimeUtil.gregorianToJalali(item.created_at)}</p>
                                        </Grid>

                                        <Grid item xs={4}>
                                            <p style={{
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'black',
                                                fontSize: 14
                                            }}
                                               align='center'><strong>{"عنوان"}</strong></p>
                                        </Grid>

                                        <Grid item xs={3}>
                                            <p style={{
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'black',
                                                fontSize: 14
                                            }}
                                               align='center'><strong>{"قیمت"}</strong></p>
                                        </Grid>

                                        <Grid item xs={2}>
                                            <p style={{
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'black',
                                                fontSize: 14
                                            }}
                                               align='center'><strong>{"تعداد"}</strong></p>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <p style={{
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'black',
                                                fontSize: 14
                                            }}
                                               align='center'><strong>{"مجموع"}</strong></p>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div style={{background: '#e7e7e7', height: 1}}/>
                                        </Grid>

                                        {
                                            item.meta_orders.map((item) => (
                                                    item.product !== null ?(
                                                        <React.Fragment key={item.id}>
                                                            <Grid item xs={4}>
                                                                <p style={{
                                                                    overflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    color: 'gray', fontSize: 14
                                                                }}
                                                                   align='center'>{item.product.title}</p>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                <p style={{
                                                                    overflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    color: 'gray', fontSize: 14
                                                                }}
                                                                   align='center'>{parseInt(item.product.price) - parseInt(item.product.del_price)}</p>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <p style={{
                                                                    overflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    color: 'gray', fontSize: 14
                                                                }}
                                                                   align='center'>{item.count}</p>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                <p style={{
                                                                    overflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    color: 'gray', fontSize: 14
                                                                }}
                                                                   align='center'>{(parseInt(item.product.price) - parseInt(item.product.del_price)) * item.count}</p>
                                                            </Grid>
                                                        </React.Fragment>
                                                    ):''

                                            ))
                                        }

                                        <Grid item xs={12} style={{background: "#fafafa"}}>
                                            <p style={{
                                                paddingRight: 12,
                                                fontSize: 14
                                            }}
                                               align='right'><strong>{"آدرس: "}</strong>{item.address}</p>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <p style={{
                                                paddingRight: 12,
                                                color: '#46c139'
                                            }}
                                               align='right'>{"مجموع: " + item.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان"}</p>
                                        </Grid>

                                        {
                                            item.status === "delivery" ? <Grid style={{margin: 12}} item xs={12}>
                                                <Button onClick={() => onConfirmOrder(item.id)} variant="contained"
                                                        style={{
                                                            width: '100%',
                                                            color: 'white',
                                                            background: "green"
                                                        }}
                                                        align='right'>{"تحویل سفارش"}</Button>
                                            </Grid> : ""
                                        }

                                    </Grid>


                                </ListItemText>

                            </Paper>

                        </div>

                    </ListItem>

                ))
                }
                </List>
                <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType} sx={{width: '100%'}}>
                        {this.state.message}
                    </Alert>
                </Snackbar>
                <BottomMenu/>
            </React.Fragment>
        );

    }

}
